import sortArrayObjects from '@/helpers/sortArrayObjects';
import store from '@/store/store';
import ModalOverlay from '../../../components/ModalOverlay';
import { mapActions, mapMutations } from 'vuex';

const MediaCrudMixin = {
    components: { ModalOverlay },

    computed: {
        selectedFields: {
            get: function() {
                return store.state.mediaLibrary.selectedFields;
            },
            set: function(value) {
                this.setSelectedFields(value);
            }
        },

        currentFile: {
            get: function() {
                return store.state.mediaLibrary.currentFile;
            },
            set: function(value) {
                this.setCurrentFile(value);
            }
        },

        profession: {
            get: function() {
                return store.state.mediaLibrary.profession;
            },
            set: function(value) {
                this.setProfession(value);
            }
        },

        professions: {
            get: function() {
                return store.state.mediaLibrary.professions;
            }
        },

        imageFields: {
            get: function() {
                return store.state.mediaLibrary.imageFields;
            }
        }
    },

    data() {
        return {
            fieldsForSelect: [],
            storage: this.$storageURL,
            fieldSelectButtons: [],
        };
    },

    mounted() {
        this.getProfessions();
        this.getImageFields()
            .then(() => {
                this.setFieldsForSelect();
                this.getLibrary();
                this.setSelectedFields([]);
            });
    },

    methods: {
        ...mapActions({
            getLibrary: 'mediaLibrary/getLibrary',
            getProfessions: 'mediaLibrary/getProfessions',
            getImageFields: 'mediaLibrary/getImageFields',
            setMediaId: 'mediaLibrary/setMediaId',
        }),

        ...mapMutations({
            setCurrentSrc: 'mediaLibrary/setCurrentSrc',
            toggleEditModal: 'mediaLibrary/toggleEditModal',
            toggleDeleteModal: 'mediaLibrary/toggleDeleteModal',
            setDeleteFilename: 'mediaLibrary/setDeleteFilename',
            setCurrentFile: 'mediaLibrary/setCurrentFile',
            setSelectedFields: 'mediaLibrary/setSelectedFields',
            toggleOverlay: 'overlay/toggleModal',
            setProfession: 'mediaLibrary/setProfession',
            setErrorMessage: 'mediaLibrary/setErrorMessage'
        }),

        getProfessionIds(professions) {
            let professionIds = [];
            professions.forEach(profession => {
                if (profession.startsWith('profession-')) {
                    professionIds.push(profession.replace('profession-', ''));
                }
            });

            return professionIds;
        },

        setFieldsForSelect() {
            let fields = [];

            let imFlds = this.imageFields.sort(sortArrayObjects('name'));

            imFlds.forEach(function(field) {
                fields.push({
                    id: field.id,
                    name: field.name,
                    group:
                        field.card.section.step.name +
                        ' \\ ' +
                        field.card.section.name +
                        ' \\ ' +
                        field.card.name
                });
            });

            this.fieldsForSelect = fields;

            let buttons = [];

            this.fieldsForSelect.forEach(field => {
                if (!buttons.includes(field.name)) {
                    buttons.push(field.name);
                }
            });

            this.fieldSelectButtons = buttons;
        },

        selectAllFields() {
            let allFields = [];
            this.fieldsForSelect.forEach((field) => {
                allFields.push(field.id);
            });
            this.selectedFields = allFields;
        },

        selectAllSimilarFields(name) {
            let allFields = [];
            this.fieldsForSelect.forEach((field) => {
                if (field.name === name) {
                    allFields.push(field.id);
                }
            });
            this.selectedFields = allFields;
        },

        clearFields() {
            this.selectedFields = [];
        },

        selectAllProfessions() {
            let allProfessions = [];
            this.professions.forEach((profession) => {
                if (profession.name !== 'Select Profession') {
                    allProfessions.push(profession.id);
                }
            });
            this.profession = allProfessions;
        },

        clearProfessions() {
            this.profession = [];
        },

        removeField(item) {
            const index = this.selectedFields.indexOf(item.id);
            if (index >= 0) this.selectedFields.splice(index, 1);
        },

        removeProfession(item) {
            const index = this.profession.indexOf(item.id);
            if (index >= 0) this.profession.splice(index, 1);
        },
    },
};

export default MediaCrudMixin;
